
function is(regex) {
    const regexp = new RegExp(regex)
    const matched = window.location.pathname.match(regexp)
    return matched !== null && matched.length > 0 ? true : false
}

export default {
    is
}
